import React from 'react'

// DXF Layer — Package 9-10. Pure rendering component: receives
// already-normalized entities (produced by dxfParser.worker.js) plus
// the SAME zoom/pan/pageWidth/pageHeight values TakeoffCanvas already
// computes for PDF rendering. It introduces NO second coordinate
// system, NO second Zoom/Pan state, and NO second interaction layer —
// it is rendered inside the exact same transformed <svg> stack that
// PdfTileLayer's sibling layers already use in TakeoffCanvas.jsx.
//
// FIX: viewport culling removed. viewportRect is expressed in
// PAGE-space (0..PAGE_BASE_WIDTH/HEIGHT, ~900px) because it was
// designed for PDF tile culling — but DXF entities keep their RAW
// native coordinates (which can be in the hundreds/thousands, in a
// completely different coordinate space). Comparing a DXF entity's
// raw bbox against a PDF-page-space viewportRect was rejecting most
// of the drawing as "outside the viewport" even though it is fully
// visible on screen after the Fit-to-View zoom/pan transform — this
// was the cause of only a few edge entities appearing. All supported
// entities are now always rendered; DXF files in this phase are small
// enough (tens of entities) that this has no measurable performance
// cost. Re-introducing culling later would need a DXF-native bounding
// check (comparing against the current zoom/pan-derived visible DXF
// coordinate range), not the PDF page-space viewportRect.
export default function DxfLayer({ entities, zoom }) {
  const strokeWidth = 1 / zoom

  return (
    <g>
      {entities.map((e, idx) => {
        if (e.type === 'LINE') {
          return <line key={idx} x1={e.points[0].x} y1={e.points[0].y} x2={e.points[1].x} y2={e.points[1].y} stroke="#374151" strokeWidth={strokeWidth} />
        }
        if (e.type === 'LWPOLYLINE' || e.type === 'POLYLINE') {
          return <polyline key={idx} points={e.points.map((p) => `${p.x},${p.y}`).join(' ')} fill="none" stroke="#374151" strokeWidth={strokeWidth} />
        }
        if (e.type === 'CIRCLE') {
          return <circle key={idx} cx={e.center.x} cy={e.center.y} r={e.radius} fill="none" stroke="#374151" strokeWidth={strokeWidth} />
        }
        if (e.type === 'ARC') {
          const startX = e.center.x + e.radius * Math.cos(e.startAngle)
          const startY = e.center.y + e.radius * Math.sin(e.startAngle)
          const endX = e.center.x + e.radius * Math.cos(e.endAngle)
          const endY = e.center.y + e.radius * Math.sin(e.endAngle)
          const largeArc = (e.endAngle - e.startAngle) % (2 * Math.PI) > Math.PI ? 1 : 0
          return <path key={idx} d={`M ${startX} ${startY} A ${e.radius} ${e.radius} 0 ${largeArc} 1 ${endX} ${endY}`} fill="none" stroke="#374151" strokeWidth={strokeWidth} />
        }
        return null
      })}
    </g>
  )
}
